export interface ScivalUnidadAutorDTO {
    idScivalUnidadAutor: number,
    idScivalAutor: number,
    idUnidad: number,
    nombreUnidad: string,
    fechaCorte: Date | null,
    estado: string,
}

export function GetVoidScivalUnidadAutorDTO(): ScivalUnidadAutorDTO {
    return {
        idScivalUnidadAutor: 0,
        idScivalAutor: 0,
        idUnidad: 0,
        nombreUnidad: '',
        fechaCorte: null,
        estado: '',
    }
}

export interface ScivalAutorDTO {
    idScivalAutor: number,
    scopusNombreAutor: string,
    scopusId: string,
    idPersona: number,
    nombreCompleto: string,
    orcId: string,
    hIndex: number,
    unidades: Array<ScivalUnidadAutorDTO>,
    estado: string,
}

export function GetVoidScivalAutorDTO(): ScivalAutorDTO {
    return {
        idScivalAutor: 0,
        scopusNombreAutor: '',
        scopusId: '',
        idPersona: 0,
        nombreCompleto: '',
        orcId: '',
        hIndex: 0,
        unidades: [],
        estado: '',
    }
}